import { render, staticRenderFns } from "./IPRadioObject.vue?vue&type=template&id=128dd01a&scoped=true"
import script from "./IPRadioObject.vue?vue&type=script&lang=js"
export * from "./IPRadioObject.vue?vue&type=script&lang=js"
import style0 from "./IPRadioObject.vue?vue&type=style&index=0&id=128dd01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128dd01a",
  null
  
)

export default component.exports